import { ColumnsType } from 'antd/lib/table'
import { NO_DATA } from 'constants/common'
import { useTranslation } from 'react-i18next'

const useColumnFactory = <T,>() => {
  const { t } = useTranslation()
  const createColumns = (columns: ColumnsType<T>): ColumnsType<T> => {
    return columns.map((column) => {
      const title = column?.title || ''
      return {
        render: (value) =>
          value !== undefined && value !== '' ? value : NO_DATA,
        ...column,
        title: t(title as string),
        key: title?.toString()
      }
    })
  }
  return {
    createColumns
  }
}
export default useColumnFactory
